import React, { Component } from "react";
import TopNav from "../containers/TopNav/TopNav";
import Footer from "../containers/Footer";
import { Translate } from "react-redux-i18n";

import TranslatedPage from "../containers/TranslatedPage";
import IconFromPath from "../containers/TranslatedPage/IconFromPath";
import { Button } from "@blueprintjs/core";
import Image from "../components/Image";
import AppWrapper from "../containers/AppWrapper";
import CreateNewCircleDecorator from "../containers/CreateNewCircleDecorator";

class WhyCoOwn extends Component {
  render() {
    return (
      <AppWrapper>
        <TopNav />
        <section className="gray-bg">
          <div className="main-container">
            <div className="content-wrapper has-sidebar">
              <div className="wide-content">
                <div className="custom-card">
                  <h1>
                    <TranslatedPage path="home.content_blocks.advantages_of_co_owning_header.heading" />
                  </h1>
                  <div className="feature-list why-co-own-detailed large how-it-works">
                    <hr />
                    <div className="feature-item">
                      <div className="icon-wrapper">
                        <IconFromPath
                          iconSize="40"
                          className="icon primary-color"
                          path="home.content_blocks.advantages_of_co_owning_save_money.icon"
                          custom={true}
                        />
                      </div>
                      <div className="feature-copy">
                        <h2 className="bp3-heading">
                          <TranslatedPage path="home.content_blocks.advantages_of_co_owning_save_money.heading" />
                        </h2>
                        <TranslatedPage path="home.content_blocks.advantages_of_co_owning_save_money.content" />
                      </div>
                    </div>

                    <div className="feature-item">
                      <div className="icon-wrapper">
                        <IconFromPath
                          iconSize="36"
                          className="icon primary-color"
                          path="home.content_blocks.advantages_of_co_owning_save_storage.icon"
                          custom={false}
                        />
                      </div>
                      <div className="feature-copy">
                        <h2 className="bp3-heading">
                          <TranslatedPage path="home.content_blocks.advantages_of_co_owning_save_storage.heading" />
                        </h2>
                        <TranslatedPage path="home.content_blocks.advantages_of_co_owning_save_storage.content" />
                      </div>
                    </div>

                    <div className="feature-item">
                      <div className="icon-wrapper">
                        <IconFromPath
                          iconSize="40"
                          className="icon primary-color"
                          path="home.content_blocks.advantages_of_co_owning_save_environment.icon"
                          custom={true}
                        />
                      </div>
                      <div className="feature-copy">
                        <h2 className="bp3-heading">
                          <TranslatedPage path="home.content_blocks.advantages_of_co_owning_save_environment.heading" />
                        </h2>
                        <TranslatedPage path="home.content_blocks.advantages_of_co_owning_save_environment.content" />
                      </div>
                    </div>
                    <CreateNewCircleDecorator empty_circle >
                      <Button intent="primary" fill={true} className="top-margin-16">
                        <Translate value="why_co_own.cta" />
                      </Button>
                    </CreateNewCircleDecorator>
                  </div>
                </div>
              </div>
              <div className="sidebar-content">
                <div className="custom-card">
                  <h1>
                    <TranslatedPage path="why-co-own.content_blocks.why_co_own_detailed_secure_sharing.heading" />
                  </h1>
                  <hr />
                  <div className="checkbox-list">
                    <TranslatedPage path="why-co-own.content_blocks.why_co_own_detailed_secure_sharing_list.content" />
                  </div>
                </div>
                <div className="custom-card">
                  <h1>
                    <Translate value="why_co_own.our_partners" />
                  </h1>
                  <div className="partner-listing">
                    <a href="https://www.sharin.se/" target="_blank" rel="noopener noreferrer" className="partner-item">
                      <Image src={require("../styles/images/logo-sharin.png")} alt="Sharin - Partner" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </AppWrapper>
    );
  }
}
export default WhyCoOwn;
